import axios from "axios";

// Base URL from .env
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Create an Axios instance
const api = axios.create({
  baseURL: API_BASE_URL
});


// Function to get the Bearer token (e.g., from localStorage)
const getToken = () => localStorage.getItem("token")?.replaceAll('"','');

// Generic API request function
const request = async (method, url, data = null, params = {}) => {
  try {
    const token = getToken(); // Get token

    const isFormData = data instanceof FormData;
    // console.log("token",token)
    const headers = {
      ...(token && { "Authorization": `Bearer `+token }),
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
    };

    const response = await api({
      method,
      url,
      data,
      params, // Attach query params
      headers, // Attach Authorization header
    });

    return response.data;
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} ${url}:`, error);
    if(error.response?.data?.message === "Unauthenticated."){
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      window.location.href = '/';
    }
    throw error.response?.data || "An error occurred";
  }
};

// Export API functions
export const apiService = {
  get: (url, params = {}) => request("get", url, null, params),
  post: (url, data) => request("post", url, data),
  put: (url, data) => request("put", url, data),
  delete: (url) => request("delete", url),
};
